// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import UIFlex from 'UIComponents/layout/UIFlex';
import InProgressDot from '../../../components/ContentCards/ReducedContentCard/subcomponents/InProgressDot';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadoutContainer = styled(UIBox).withConfig({
  displayName: "LearningContentTimeReadout__ReadoutContainer",
  componentId: "sc-1tw1mwf-0"
})(["display:flex;&::after{content:'';margin:0 10px 0 10px;display:inline-flex;align-self:center;height:100%;}"]);
const InProgressLargeCardDot = styled(InProgressDot).withConfig({
  displayName: "LearningContentTimeReadout__InProgressLargeCardDot",
  componentId: "sc-1tw1mwf-1"
})(["bottom:-9px;margin-left:3px;margin-right:9px;"]);
const ReadoutContainerUnstarted = styled(ReadoutContainer).withConfig({
  displayName: "LearningContentTimeReadout__ReadoutContainerUnstarted",
  componentId: "sc-1tw1mwf-2"
})(["&::after{border-left:1px solid ", ";height:10px;}"], theme.colors.BATTLESHIP);
export const ShortTimeReadout = ({
  duration,
  progress
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null; // progress can be undefined (loading) or null (error/not found)
  return /*#__PURE__*/_jsx(UIFlex, {
    children: /*#__PURE__*/_jsx(FormattedDuration, {
      from: Date.now() - duration * 1000
    })
  });
};
export const LessonTimeReadout = ({
  duration,
  progress
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null; // progress can be undefined (loading) or null (error/not found)

  const {
    status,
    remainingDuration
  } = progress || {};
  const showProgress = !!remainingDuration && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutContainer, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.timeRemaining.duration",
          options: {
            duration: /*#__PURE__*/_jsx(FormattedDuration, {
              from: Date.now() - remainingDuration * 1000
            })
          }
        })
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: Date.now() - duration * 1000
      })
    })]
  });
};
export const TrackTimeReadout = ({
  duration,
  progress,
  totalItems
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null; // progress can be undefined (loading) or null (error/not found)

  const {
    status,
    remainingDuration,
    completedLessonIds
  } = progress || {};
  const remainingLessons = totalItems - ((completedLessonIds === null || completedLessonIds === void 0 ? void 0 : completedLessonIds.length) || 0);
  const showProgress = !!remainingDuration && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress ? /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutContainer, {
        children: /*#__PURE__*/_jsxs(FormattedList, {
          exclusive: true,
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-total-lessons",
            message: "academyComponents.reducedContentCards.numLessonsRemaining",
            options: {
              remainingNumber: remainingLessons,
              totalNumber: totalItems
            }
          }), /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.tracks.timeRemaining.duration",
            options: {
              duration: /*#__PURE__*/_jsx(FormattedDuration, {
                from: new Date().getTime() - remainingDuration * 1000
              })
            }
          })]
        })
      })
    }) : remainingLessons > 0 && /*#__PURE__*/_jsx(ReadoutContainerUnstarted, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "track-total-lessons",
        message: "academyComponents.reducedContentCards.numLessonsRemainingUnstarted",
        options: {
          remainingNumber: remainingLessons
        }
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: Date.now() - duration * 1000
      })
    })]
  });
};
export const PlaylistTimeReadout = ({
  progress,
  totalItems
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null; // progress can be undefined (loading) or null (error/not found)

  const {
    status,
    completedItemsCount
  } = progress || {};
  const showProgress = !!completedItemsCount && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutContainer, {
        children: /*#__PURE__*/_jsx(FormattedList, {
          exclusive: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.reducedContentCards.numItemsRemaining",
            options: {
              remainingNumber: totalItems - completedItemsCount,
              totalNumber: totalItems
            }
          })
        })
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.reducedContentCards.items",
        options: {
          itemsCount: totalItems
        }
      })
    })]
  });
};
export const LearningContentTimeReadout = ({
  item
}) => {
  const {
    type
  } = item;
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      {
        const {
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(ShortTimeReadout, {
          duration: duration,
          progress: progress
        });
      }
    case 'LESSON':
      {
        const {
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(LessonTimeReadout, {
          duration: duration,
          progress: progress
        });
      }
    case 'TRACK':
      {
        const {
          lessonIds,
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(TrackTimeReadout, {
          duration: duration,
          progress: progress,
          totalItems: lessonIds.length
        });
      }
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      {
        const {
          progress,
          itemsCount
        } = item;
        return /*#__PURE__*/_jsx(PlaylistTimeReadout, {
          progress: progress,
          totalItems: itemsCount
        });
      }
    default:
      return null;
  }
};